/* Marinelie — der Zaehler auf der Passwortseite.

   Tage, Stunden, Minuten bis zum Oeffnen. Drei Regeln:

   1. Das Ziel steht als data-ziel am Element, im Format
      2026-09-30T18:00:00+02:00. Steht dort Unsinn oder liegt der Zeitpunkt
      in der Vergangenheit, bleibt der Zaehler versteckt — ein Zaehler auf
      null ist schlimmer als keiner.
   2. Er startet versteckt und zeigt sich erst, wenn er etwas zu sagen hat.
      Sonst blitzen beim Laden drei Striche auf.
   3. Getickt wird jede Minute, nicht jede Sekunde: die kleinste Einheit
      auf der Seite ist die Minute, ein Sekundentakt waere 60 mal so viel
      Arbeit fuer dasselbe Bild. */

(function () {
  'use strict';

  var box = document.querySelector('[data-pw-zaehler]');
  if (!box) return;

  var ziel = Date.parse(box.getAttribute('data-ziel') || '');
  if (isNaN(ziel)) return;

  var tage = box.querySelector('[data-pw-tage]');
  var std = box.querySelector('[data-pw-std]');
  var min = box.querySelector('[data-pw-min]');

  function ticken() {
    var rest = ziel - Date.now();
    if (rest <= 0) { box.hidden = true; return false; }

    var m = Math.floor(rest / 60000);
    var t = Math.floor(m / 1440);
    var h = Math.floor((m % 1440) / 60);

    if (tage) tage.textContent = t;
    if (std) std.textContent = h;
    if (min) min.textContent = m % 60;
    box.hidden = false;
    return true;
  }

  if (!ticken()) return;
  setInterval(ticken, 60000);
})();
